<template>
  <header>
    <div class="logoSVE">
      <img class="logo" src="@/assets/LogoOriginalSVE.png" alt="Logo SVE">
      <span class="textoLogo">Sociedad Venezolana de Espeleología</span>
    </div>
    <div class="titulo">
      <h2 >Catálogo de la biblioteca</h2>
    </div>
    <div class="resto">
      <div class="contLogoUser">
        <img class="logoUser" :src="icoUsuario" alt="Logo user">
        <span>{{usuarioEnSesion.nombre}}</span>
      </div>
      <div>
        <img class="icoSalir" src="@/assets/icoSalir.png" @click="closeSession">
      </div>
    </div>
  </header>
</template>

<script>
import icoUserSVE from '@/assets/IcoMiembroSVE.png'
import icoUserReg from '@/assets/icoUserReg.png'
import { mapState } from 'vuex'
export default {
  name: 'HeaderGestion',
  created () {
    if (this.usuarioEnSesion.nombre === undefined) {
      this.$router.push('/')
    }
    this.icoUsuario = this.usuarioEnSesion.tipoUsuario > 0 ? icoUserSVE : icoUserReg
  },
  methods: {
    closeSession () {
      this.$store.commit('doLogout')
      this.$router.push('/')
    }
  },
  computed: {
    ...mapState(['usuarioEnSesion'])
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
header {
  height: 10vh;
  background-color: var(--az-me-tr05);
  /* background-color: rgb(10, 90, 140, 0.6); */
  display: grid;
  grid-template-columns: 22% 48% 30%;
  align-items:center;
}
.logoSVE{
  /* border: solid 1px orange; */
  color:  rgb(250, 251, 251);
  display: grid;
  grid-template-columns: 30% 70%;
}
.logo{
  width: 45%;
  /* border: solid 1px orange; */
  justify-self:right;
  align-self: center;
  margin-right: 0.4rem;
}
.textoLogo{
  /* border: solid 1px orange; */
  width: 90%;
  text-align:left;
  font-family:ErasMD;
  padding-top: 0.15rem;
  font-size: 1.4vw;
}
.titulo h2{
  /* color:  rgb(185, 227, 255); */
  color:  rgb(168, 168, 168);
  font-weight: 200;
  font-size: 30px;
  padding-left: 19%;

  /* border: solid 1px orange; */
}
.resto{
  color:  rgb(251, 251, 251);
  /* border: solid 1px orange; */
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.resto span{
 /* border: solid 1px orange; */
 margin-right: 25px;
}
.contLogoUser{
  display:flex;
  align-items: center;
}
.logoUser{
  /* border:  1px solid rgb(247, 222, 2); */
 /* display: inline-block; */
 /* position: relative; */
 /* width: 32px; */
 height: 32px;
 overflow: hidden;
 /* border-radius: 50%; */
 margin-right: 15px;
 justify-self: center;
 /* margin-top: 10px; */
 /* margin-left: 15px; */
}
.icoSalir{
  height: 20px;
  cursor: pointer;
  margin-right: 25px;
  transition: all 0.5s ease-out;
}
.icoSalir:hover{
  transform: translateX(-5px);
}
header h1 {
  font-weight: lighter;
  font-size: 3vw;
  text-justify: auto ;
}
@media screen and (max-width: 575px){
  .titulo{
    display: none;
  }
  header {
    grid-template-columns: 45% 55%;
  }
  .logo{
    width: 55%;
    justify-self: center;
    align-self: center;
    margin-left: 0.7rem;
    /* border:  1px solid rgb(247, 222, 2); */
  }
  .textoLogo{
    width: 100%;
    padding-top: 0.09rem;
    justify-self: left;
    font-size: 3.2vw;
    /* border:  1px solid rgb(247, 222, 2); */
  }
  .logoUser{
    /* width: 23px; */
    height: 23px;
   }
  .contLogoUser span{
    font-size: 14px;
  }
}
</style>
